wbApp.controller('NotificationSettingsCtrl', ['$scope', '$q', '$translate', 'userSettingSvc', 'tenantSettingSvc', 'notificationSvc',
function ($scope, $q, $translate, userSettingSvc, tenantSettingSvc, notificationSvc) {

    var isActive = false;
    var loaded = false;

    function loadData() {
        $scope.isBusy = true;
        $scope.userSettingSrc = userSettingSvc.getAsync();
        $scope.tenantSetting = {};
        $scope.tenantSettingSrc = tenantSettingSvc.getAsync();
        $q.all([$scope.userSettingSrc.$promise, $scope.tenantSettingSrc.$promise]).then(function () {
            $scope.userSetting = angular.copy($scope.userSettingSrc);
            $scope.userSettingOrig = angular.copy($scope.userSettingSrc);
            $scope.tenantSetting = angular.copy($scope.tenantSettingSrc);
            $scope.tenantSettingOrig = angular.copy($scope.tenantSettingSrc);

            $scope.isBusy = false;
        });
    }

    $scope.$on('refreshData', function (e, data) {
        if (isActive) {
            loadData();
        }
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 3) {
            if (!isActive) {
                isActive = true;

                if (!loaded) {
                    loadData();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.onCancel = function () {
        loadData();
    }

    $scope.onModelSave = function (userSettingData, tenantSettingData) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        var updates = 0;

        if (!$scope.userSettingIsUnchanged(userSettingData)) {
            updates++;

            userSettingSvc.saveAsync(userSettingData, function (model) {
                $scope.userSetting = angular.copy(model);
                $scope.userSettingOrig = angular.copy(model);

                updates--;
                if (!updates) {
                    $scope.isSaving = false;
                }
            }, function (errorResult) {
                updates--;
                if (!updates) {
                    $scope.isSaving = false;
                }

                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                    notificationSvc.translateError(errorResult));
            });
        }

        if (!$scope.tenantSettingIsUnchanged(tenantSettingData)) {
            updates++;

            var tenantSettingCurrent = tenantSettingSvc.getAsync();
            tenantSettingCurrent.$promise.then(function (current) {

                // Set only fields which we do set on this tab
                current.sendEmailsToClients = tenantSettingData.sendEmailsToClients;
                current.disableInformTeachers = tenantSettingData.disableInformTeachers;
                current.enableSMSSupport = tenantSettingData.enableSMSSupport;
                current.courseRegistrationQuestionCCToTeacher = tenantSettingData.courseRegistrationQuestionCCToTeacher;
                current.disableAllEmails = tenantSettingData.disableAllEmails;
                current.disableAllEmailsExceptUserRegistration = tenantSettingData.disableAllEmailsExceptUserRegistration;
                current.allowTeacherEmailInClientSection = tenantSettingData.allowTeacherEmailInClientSection;
                current.enableUserCreatedNotification = tenantSettingData.enableUserCreatedNotification;
                current.enableCoursePaymentEvidenceNotification = tenantSettingData.enableCoursePaymentEvidenceNotification;
                current.enableAttendanceExcusedCancelledNotification = tenantSettingData.enableAttendanceExcusedCancelledNotification;
                current.enableCourseScheduleDateChangedNotification = tenantSettingData.enableCourseScheduleDateChangedNotification;
                current.enableStudentActionRegistrationDeleteNotification = tenantSettingData.enableStudentActionRegistrationDeleteNotification;
                current.enableStudentCourseRegistrationPriceChangeNotification = tenantSettingData.enableStudentCourseRegistrationPriceChangeNotification;
                current.enableAttendanceActionExcusedCancelledNotification = tenantSettingData.enableAttendanceActionExcusedCancelledNotification;
                current.enableStudentAddedToWaitQueueNotification = tenantSettingData.enableStudentAddedToWaitQueueNotification;
                current.enableStudentRemovedFromActionWaitQueueNotification = tenantSettingData.enableStudentRemovedFromActionWaitQueueNotification;
                current.enableAttendancePreviewInterestNotification = tenantSettingData.enableAttendancePreviewInterestNotification;
                current.enableUserPasswordChangedNotification = tenantSettingData.enableUserPasswordChangedNotification;
                current.enableAttendanceExcusedNotification = tenantSettingData.enableAttendanceExcusedNotification;
                current.enableAttendanceNewOneOffNotification = tenantSettingData.enableAttendanceNewOneOffNotification;
                current.enableCourseScheduleTeacherChangedNotification = tenantSettingData.enableCourseScheduleTeacherChangedNotification;
                current.enableSendRequestForPaymentNotification = tenantSettingData.enableSendRequestForPaymentNotification;
                current.enableAttendanceActionExcusedNotification = tenantSettingData.enableAttendanceActionExcusedNotification;
                current.enableStudentCourseInterestRegistrationNotification = tenantSettingData.enableStudentCourseInterestRegistrationNotification;
                current.enableStudentRemovedFromWaitQueueNotification = tenantSettingData.enableStudentRemovedFromWaitQueueNotification;
                current.enableNotExcusedNotification = tenantSettingData.enableNotExcusedNotification;
                current.enableStudentActionRegistrationPriceChange = tenantSettingData.enableStudentActionRegistrationPriceChange;
                current.enableStudentCourseRegistrationNotification = tenantSettingData.enableStudentCourseRegistrationNotification;
                current.enableAttendanceExcusedNoCompensationNotification = tenantSettingData.enableAttendanceExcusedNoCompensationNotification;
                current.enableAttendanceNewAmendNotification = tenantSettingData.enableAttendanceNewAmendNotification;
                current.enableStudentActionRegistrationNotification = tenantSettingData.enableStudentActionRegistrationNotification;
                current.enableCourseScheduleNoteChangedNotification = tenantSettingData.enableCourseScheduleNoteChangedNotification;
                current.enableAttendanceActionExcusedNoCompensationNotification = tenantSettingData.enableAttendanceActionExcusedNoCompensationNotification;
                current.enableAttendanceNoteChangedNotification = tenantSettingData.enableAttendanceNoteChangedNotification;
                current.enableStudentAddedToActionWaitQueueNotification = tenantSettingData.enableStudentAddedToActionWaitQueueNotification;
                current.enableAttendancePreviewNotification = tenantSettingData.enableAttendancePreviewNotification;
                current.coursePaymentEvidenceCCTeacher = tenantSettingData.coursePaymentEvidenceCCTeacher;


                current.enableActivityAttendanceChangeNotification = tenantSettingData.enableActivityAttendanceChangeNotification;
                current.enableActivityReconciliationCreatedNotification = tenantSettingData.enableActivityReconciliationCreatedNotification;
                current.enableActivityReconciliationPaymentEvidenceNotification = tenantSettingData.enableActivityReconciliationPaymentEvidenceNotification;
                current.enableActivityAttendanceFoodTakenNotification = tenantSettingData.enableActivityAttendanceFoodTakenNotification;
                current.enableActivityFoodOrderNotification = tenantSettingData.enableActivityFoodOrderNotification;
                current.enableRegisterActivityInterestNotification = tenantSettingData.enableRegisterActivityInterestNotification;
                current.enableSurveyRequestNotification = tenantSettingData.enableSurveyRequestNotification;
                current.enableCourseRegistrationQuestionNotification = tenantSettingData.enableCourseRegistrationQuestionNotification;
                current.enableOnlineLessonReminderNotification = tenantSettingData.enableOnlineLessonReminderNotification;
                current.enableOnlineLessonStartedNotification = tenantSettingData.enableOnlineLessonStartedNotification;
                current.enableScheduledInvoiceIssuedNotification = tenantSettingData.enableScheduledInvoiceIssuedNotification;
                current.enableActivityScheduleNoteChangeNotification = tenantSettingData.enableActivityScheduleNoteChangeNotification;                
                current.enableTaxDocumentCreatedNotification = tenantSettingData.enableTaxDocumentCreatedNotification;
                current.enableNewConsentAssignedNotification = tenantSettingData.enableNewConsentAssignedNotification;
                current.enableAmortizationSchedulePaymentNotification = tenantSettingData.enableAmortizationSchedulePaymentNotification;

                current.enableFormResponseCreatedNotification = tenantSettingData.enableFormResponseCreatedNotification;
                current.enableFullCourseInterestNotification = tenantSettingData.enableFullCourseInterestNotification;
                current.enableStudentActionRegistrationAutoDeleteNotification = tenantSettingData.enableStudentActionRegistrationAutoDeleteNotification;
                current.EnableOnlineMeetingRecordingCompletedNotification = tenantSettingData.enableOnlineMeetingRecordingCompletedNotification;

                current.enableReservationPaymentEvidenceNotification = tenantSettingData.enableReservationPaymentEvidenceNotification;

                tenantSettingSvc.update(current, function (model) {
                    $scope.tenantSetting = angular.copy(model);
                    $scope.tenantSettingOrig = angular.copy(model);

                    updates--;
                    if (!updates) {
                        $scope.isSaving = false;
                    }
                }, function (errorResult) {
                    updates--;
                    if (!updates) {
                        $scope.isSaving = false;
                    }

                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult));
                });
            });
        }
    }

    $scope.userSettingIsUnchanged = function (data) {
        return angular.equals(data, $scope.userSettingOrig);
    }

    $scope.tenantSettingIsUnchanged = function (data) {
        return angular.equals(data, $scope.tenantSettingOrig);
    }

    $scope.detailIsUnchanged = function (userSettingData, tenantSettingData) {
        return $scope.userSettingIsUnchanged(userSettingData) &&
            $scope.tenantSettingIsUnchanged(tenantSettingData);
    }
}]);
